/**
 * Events Load More
 * Handles AJAX pagination for events archive
 */

class EventsLoadMore {
  constructor() {
    this.button = document.querySelector('[data-load-more-events]');
    this.container = document.querySelector('[data-events-container]');
    
    if (!this.button || !this.container) return;
    
    this.isLoading = false;
    this.currentPage = parseInt(this.button.dataset.currentPage) || 1;
    this.maxPages = parseInt(this.button.dataset.maxPages) || 1;
    
    this.init();
  }
  
  init() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }
  
  async loadMore() {
    if (this.isLoading) return;
    
    const nextPage = this.currentPage + 1;
    
    if (nextPage > this.maxPages) {
      this.hideButton();
      return;
    }
    
    this.setLoadingState(true);
    
    try {
      const formData = new FormData();
      formData.append('action', 'load_more_events');
      formData.append('page', nextPage);
      formData.append('nonce', stablevineAjax.nonce);
      
      const response = await fetch(stablevineAjax.ajaxurl, {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        // Insert new events
        this.container.insertAdjacentHTML('beforeend', data.data.html);
        
        // Update current page
        this.currentPage = data.data.current_page;
        this.button.dataset.currentPage = this.currentPage;
        
        // Hide button if no more pages
        if (this.currentPage >= data.data.max_pages) {
          this.hideButton();
        }
      } else {
        console.error('Error loading events:', data.data.message);
        this.hideButton();
      }
    } catch (error) {
      console.error('AJAX error:', error);
    } finally {
      this.setLoadingState(false);
    }
  }
  
  setLoadingState(loading) {
    this.isLoading = loading;
    
    if (loading) {
      this.button.style.pointerEvents = 'none';
      this.button.style.opacity = '0.6';
      this.button.textContent = 'Loading...';
    } else {
      this.button.style.pointerEvents = '';
      this.button.style.opacity = '';
      this.button.textContent = 'View More';
    }
  }
  
  hideButton() {
    this.button.style.display = 'none';
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new EventsLoadMore();
  });
} else {
  new EventsLoadMore();
}

export default EventsLoadMore;
